// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // host: 'https://clir.senzmatica.com/service/'
  host: 'https://clir.senzmatica.com/service/',
  client_id:"polar-client",
  client_secret:"polar-secret",
  googleMapKey: 'AIzaSyAca9W5Y8feCn8ni1s7jV7tjPICtWcMvD8',
  azureAd: {
    clientId:'78414668-f799-441b-9c3a-8ab3a4733117',
    tenantId: 'common'
    },
  azure:{
    planEntryId:"plan-test01",
    planSnapId:"plan-test02"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
